const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

/** Haalt een PDF op met auth-token en opent deze in een nieuw tabblad. */
export async function openPdf(path: string, token: string): Promise<void> {
  const res = await fetch(`${API_BASE_URL}${path}`, { headers: { Authorization: `Bearer ${token}` } });
  if (!res.ok) {
    alert('Document kon niet worden geopend.');
    return;
  }
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  window.open(url, '_blank');
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}
